import { render, staticRenderFns } from "./DrawerCustomiseCover.vue?vue&type=template&id=0caeb288&scoped=true&"
import script from "./DrawerCustomiseCover.vue?vue&type=script&lang=js&"
export * from "./DrawerCustomiseCover.vue?vue&type=script&lang=js&"
import style0 from "./DrawerCustomiseCover.vue?vue&type=style&index=0&id=0caeb288&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caeb288",
  null
  
)

export default component.exports